  // STYLE
  // Changing the style if in error

export const getTextFieldInputCssClass = (isInError : boolean, ) => {
    if(isInError == false || isInError == undefined)
    {
      return 'text-field-icon';
    }
    else
    {
      return 'text-field-icon';
    }
  };

export const getInputCssClass = (isInError : boolean, ) => {
      if(isInError == false || isInError == undefined)
      {
        return 'text-field w-input';
      }
      else
      {
        return 'text-field w-input textfieldError inputTextError';
      }
    };